import { Result } from "antd";
import { useEffect } from "react";
import PageBanner from "../../components/PageBanner";
import PageBreadcrumb from "../../components/PageBreadcrumb";
import PageLayout from "../../components/PageLayout";
import StandardPageBlock from "../../components/StandardPageBlock";
import { getImageById } from "../../getters/images";
import { setPageTitle } from "../../utils";

const breadcrumbs = [{ link: "", value: "Projets à venir" }];

const ProjectsComing = () => {
  useEffect(() => {
    setPageTitle("Projets à venir");
  }, []); // eslint-disable-line

  return (
    <div className="projects">
      <PageLayout>
        <>
          <PageBanner
            image={getImageById("1646455366852")}
            title="Nos projets à venir"
          />
          <PageBreadcrumb items={breadcrumbs} />
          <StandardPageBlock>
            <Result
              status={404}
              title="Nous élaborons de nouveaux projets ..."
            />
          </StandardPageBlock>
        </>
      </PageLayout>
    </div>
  );
};

export default ProjectsComing;
